import styled, {css} from 'styled-components';
import {
  tabletAndUp,
  desktopAndUp,
  largeScreens,
} from '../../../constants/customMedia';

export interface RowSectionProps {
  dataTestId?: string;
  pullStart?: boolean;
  pullEnd?: boolean;
  centerContent?: boolean;
  constrained?: boolean;
}

export const RowSection = styled.section<RowSectionProps>`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  max-width: 1920px;
  padding-left: 0;
  padding-right: 0;

  ${({centerContent}) =>
    centerContent &&
    css`
      display: flex;
      justify-content: center;
    `}

  ${({constrained}) =>
    constrained
      ? null
      : css`
          ${tabletAndUp(css`
            padding-left: 20px;
            padding-right: 20px;
          `)}

          ${desktopAndUp(css`
            padding-left: 30px;
            padding-right: 30px;
          `)}

          ${largeScreens(css`
            padding-left: 60px;
            padding-right: 60px;
          `)}
        `};

  ${({pullStart}) =>
    pullStart
      ? css`
          padding-left: 0 !important;
        `
      : null};
  ${({pullEnd}) =>
    pullEnd
      ? css`
          padding-right: 0 !important;
        `
      : null};
`;
